import React from 'react';
import { Info } from 'lucide-react';

const InfoTooltip = ({ text }) => {
    return (
        <div className="group relative inline-flex items-center ml-2">
            <Info className="w-4 h-4 text-gray-400 hover:text-blue-500 transition-colors cursor-help" />
            <div className="absolute left-1/2 bottom-full mb-2 -translate-x-1/2 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 shadow-xl border border-gray-700">
                {text}
                <div className="absolute left-1/2 top-full -translate-x-1/2 -mt-1 border-4 border-transparent border-t-gray-900" />
            </div>
        </div>
    );
};

export default InfoTooltip;
